import React from "react";
import { TouchableOpacity, View } from "react-native";
import Typography from "../../typography/Typography";
import { ColorTokens, IconTokens, ImageSizeTokens, TypographyTypeDLS } from "@voltmoney/schema";
import Image from "../../image/Image";
import Icon from "../../icon/Icon";
import ThemeProvider from "@voltmoney/theme";
const InterestCalculatorEntryCard = ({ navAction, triggerAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    return (React.createElement(TouchableOpacity, { style: {
            position: 'relative',
            bottom: 16,
            display: 'flex',
            flexDirection: 'row',
            paddingHorizontal: 20,
            paddingVertical: 8,
            backgroundColor: colorMapping[ColorTokens.White],
            borderRadius: 10,
            borderWidth: 1,
            borderColor: colorMapping[ColorTokens.Primary_10],
        }, onPress: () => {
            navAction &&
                triggerAction(navAction);
        } },
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(Image, { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icn-calculator.svg", size: ImageSizeTokens.MD, width: 40, height: 40 })),
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'column',
                paddingHorizontal: 20,
                paddingVertical: 8,
                flex: 1,
            } },
            React.createElement(Typography, { label: "Interest Calculator", typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { height: 2 } }),
            React.createElement(Typography, { label: "Calculate EMI on loan against MF", typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { height: 2 } }),
            React.createElement(Typography, { label: "Check now", typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 })),
        React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, 
                // size={IconSizeTokens.XL}
                color: ColorTokens.Primary_100 }))));
};
export default InterestCalculatorEntryCard;
